import Filter from './FilterView'

const DisplayView = ({setOpened, setNewPlayer})=>{

    
    return(

        <Filter filter="All" setOpened={setOpened} setNewPlayer={setNewPlayer}/>
       
    )

}


export default DisplayView